
<script>
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import UserDetailsHeader from 'vRoot/account-profile/modules/manage-users/UserDetailsHeader.svelte';
  import ModalButtons from 'root/services/modals/ModalButtons.YesNo.svelte';
  import {mainAPI, notificationUtils} from 'root/angular-injector-provider';

  export let cancel, hide, userAccount;

  const types = [
    { value: 'ADMIN', label: 'Administrator' },
    { value: 'USER', label: 'Account Manager' },
  ];

  let initialUserType, userType, working = false;

  (function initialize(){
    initialUserType = types[userAccount.isAdmin? 0: 1].value;
    userType = initialUserType;
  })();

  function save(){
    working = true;
    const updateFunction = userAccount.status === 'INVITED'?
      mainAPI().manageAccount.updateInviteeType :
      mainAPI().manageAccount.updateUserType;

    notificationUtils().onSave(() => updateFunction(userAccount.accountId, userAccount._id, userType))
      .then(hide)
  }

</script>

<ClosableModal width="500px" close="{cancel}">
  <div slot="heading">
    <UserDetailsHeader
      {userAccount}
      userType="{userAccount.type}"
    />
  </div>

  <div class="Body">
    <div class="List">
      {#each types as type}
        <div class="Item"
             data-icon-before="{userType === type.value? 'radio_button_checked': 'radio_button_unchecked'}"
          on:click="{() => userType = type.value}"
        >
          {type.label}
        </div>
      {/each}
    </div>
  </div>

  <ModalButtons
    disabled="{working || initialUserType === userType}"
    noAction="{cancel}"
    noLabel="Cancel"
    yesLabel="Apply Changes"
    yesIcon="account_circle"
    yesAction="{save}"
  />
</ClosableModal>

<style lang="stylus">

  .Body {
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 0 15px;
    color #546E7A;
    font-size 13px;
  }

  .List {
    overflow: auto;
    max-height: 50vh;
    border: 1px solid #B0BEC5;
    border-radius: 5px;
  }

  .Item {
    padding: 10px;
    height: 42px;
    border-bottom: 1px solid #eceff1;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    &:before {
      font-size: 20px;
      margin-right: 5px;
    }
  }

</style>
